import React from "react";
import { ResetPasswordTemplate } from "../../Templates/ResetPasswordTemplate";

export const ResetPassword = () => {
  return <ResetPasswordTemplate />;
};
